import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
  pub: {
    page: {
      index: '序号'
    },
    btn: {
      search: '搜 索'
    },
    exportExcel: {
      exportExcel: '导出'
    }
  },
  taskprogress: {
    page: {
      username: '姓名',
      enterPhone: '报名手机号',
      teamName: '团队名称',
      teamNo: '团队编号',
      schoolName: '学校名称',
      gradeCode: '年级',
      groupName: '组别',
      currentTaskTitle: '当前任务',
      taskDoneCount: '任务进度',
      progressTask: '进度排行'
    },
    placeholder: {
      username: '请输入姓名'
    }
  },
  regrecord: {
    page: {
      phone: '注册账号',
      enterPhone: '报名手机号',
      email: '报名邮箱',
      username: '姓名',
      schoolName: '学校名称',
      areaName: '省份',
      contestName: '活动名称',
      gradeCode: '年级',
      groupName: '组别',
      enterTime: '报名时间',
      orderTitle: '费用名称',
      productNames: '缴费项',
      orderId: '订单ID',
      orderStatus: '是否缴费',
      payTime: '缴费时间',
      payStatus: {
        lable: '全部',
        lable1: '未缴费',
        lable2: '已取消',
        lable3: '已缴费',
        lable4: '退费中',
        lable5: '已退款'
      }
    },
    placeholder: {
      phone: '请输入报名手机号',
      username: '请输入姓名',
      orderStatus: '请选择缴费状态',
      taskRelationId: '请选择费用名称',
      AdmissionTicket: '请选择准考证',
      AcademicReport: '请选择学术报告'
    }
  },
  jobrecords: {
    placeholder: {
      username: '请输入姓名',
      selectjob: '请选择作业'
    },
    tab: {
      index: '序号',
      studentName: '姓名',
      grade: '年级',
      languageGroup: '组别',
      teamName: '团队名称',
      workGroupType: '作业类型',
      submitTime: '提交时间',
      reviewStatusName: '评审状态',
      isPassName: '是否通过',
      score: '分数',
      operate: '操作',
      view: '查看',
      task: '任务名称',
      school: '学校'
    },
    details: {
      title: '查看作业详情',
      workDetails: '作业信息',
      studentDetails: '学生信息',
      reviewDetails: '评审信息',
      Last: '上一份',
      Next: '下一份',
      Close: ''
    }
  },
  notice: {
    page: {
      name: '公告名称',
      content: '公告内容',
      files: '公告文件',
      tag: '公告类型',
      contentType: '内容类型',
      modifyTime: '发布时间'
    },
    placeholder: {
      name: '请输入公告名称',
      tag: '请输入公告类型'
    }
  },
  login: {
    username: '手机号：',
    password: '密码：',
    imgcode: '验证码：',
    smscode: '验证码：',
    title: 'Bloom教练系统',
    btnTxt: '登 录',
    placeholder: {
      username: '请输入您的手机号',
      password: '请输入您的密码',
      imgcode: '请输入图形验证码',
      smscode: '请输入短信验证码'
    },
    alert: {
      username: '请输入登录手机号',
      password: '请输入登录密码',
      imgcode: '请输入图形验证码',
      smscode: '请输入手机短信'
    }
  },
  index: {
    alert: {
      userinfo: '尊敬的教练你好，欢迎使用Bloom-教练端，在使用功能前，请先完成个人信息的填写，此信息将用于活动期间的活动公告及教练颁奖等。',  // 提醒教练完成信息填写
      logout: '已退出登录' // 退出登录提醒
    },
    btn: {
      logout: '退出' // 退出登录按钮文字
    },
    footinfo: '粤ICP备16089044号-2 ©Copyright SKT Education 版权所有 Powered by SKT Education' // 版权声明
  },
  menu: {
    user: '个人中心',
    coachdetails: '个人信息',
    UScoachdetails: '站个人信息',
    activity: '活动管理',
    teaminfo: '组队管理',
    coachfiles: '活动公告',
    event: '数据管理',
    regrecord: '报名记录',
    teamInfo: '团队信息',
    progresstask: '任务进度查询',
    gradeQuery: '线上成绩查询',
    localGradeQuery: '线下成绩查询',
    home: '首页',
    eventManagement: '活动管理',
    coachCenter: '教练中心',
    account: '账号设置',
    switchStudent: '切换学生端',
    loginOut: '退出登录'
  },
  coach: {
    page: {
      title: '个人信息/Personal information',
      title2: '请先填写个人信息，提交后方可进行其他操作。',
      title3: '所属学校'
    },
    form: {
      name: '姓名/Full Name*（请以身份证的真实姓名为准）',
      pinyinFirstName: '姓，拼音/Last Name*（请以护照姓为准，如无，请按照身份证姓名的拼音姓填写）',
      pinyinLastName: '名，拼音/First Name*（请以护照名为准，如无，请按照身份证姓名的拼音名填写）',
      phone: '手机/Phone*',
      email: '电子邮箱/Email*（后续组委会将会把大赛公告等重要信息发送至此邮箱，请确保邮箱地址填写无误）',
      courseSystem: '学校课程体系',
      coachType: '教练身份/Coach Status*',
      contacts: '更多联系人/More Contacts（其他需要接收活动公告的联系人和电子邮箱）',
      contactName: '联系人姓名/Contact Name',
      contactEmail: '电子邮箱/Email',
      placeholder: {
        name: '请输入姓名，例：李小明',
        pinyinFirstName: '请输入拼音姓，例：LI',
        pinyinLastName: '请输入拼音名，例：XIAOMING',
        phone: '请填写移动电话',
        email: '请填写电子邮箱 ',
        coachType: '请选择教练身份',
        courseSystem: '请选择学校课程体系',
        contactName: '请填写联系人姓名',
        contactEmail: '请填写联系人电子邮箱',
        examTaskName: '请选择成绩任务名称'
      },
      coachTypes: {
        label1: '学校老师',
        label2: '家长代表',
        label3: '学生代表'
      },
      courseSystems: {
        label1: 'AP',
        label2: 'IB',
        label3: 'A-level',
        label4: '加拿大课程体系',
        label5: '高考课程体系',
        label6: '其他'
      }
    },
    btn: {
      save: '保 存',
      cancel: '取 消'
    },
    alert: {
      coachId: '数据错误，请重新登录后查看',
      success: '保存成功',
      placeholder: {
        name: '请填写姓名后提交',
        pinyinFirstName: '请填写姓后提交',
        pinyinLastName: '请填写名后提交',
        phone: '请填写手机号后提交',
        email: '请填写邮箱后提交',
        coachType: '请选择教练身份后提交',
        courseSystem: '请选择学校课程体系后提交'
      }
    },
    menu: {
      courseL: '教练课程',
      certification: '认证中心'
    }
  },
  uscoach: {
    page: {
      title: '提交站个人信息/Personal information',
      title3: '请准确填写站个人信息，针对晋级站的学校教练开放。'
    },
    form: {
      upload: '上传护照首页*（请上传较高清晰度的护照照片内容）',
      firstName: '护照姓/Surname*（请以护照姓为准）',
      lastName: '护照名/Given Name*（请以护照的护照号为准）',
      passportId: '护照号/Passport ID*（请以护照的护照号为准）',
      expireDate: '护照有效期/Date of Explry* （请以护照的有效期为准）',
      birthday: '出生日期/Birthday*',
      cateringNeed: '餐饮需求/Catering Needs*',
      allergenCollection: '过敏原采集/Allergen Collection*',
      quantityOfPeople: '带队人数/Quantity of People*',
      serviceProject: '服务项目/Service Project*',
      placeholder: {
        firstName: '例：LI',
        lastName: '例：XIAOMING',
        passportId: '例： A888888',
        expireDate: '例： 2020-10-10 ',
        birthday: '例： 2020-10-10',
        cateringNeed: '请选择餐饮需求',
        cateringNeedsElse: '如有其它需求，请在此填写',
        allergenCollection: '请输入过敏原采集',
        quantityOfPeople: '请输入带队人数',
        serviceProject: '请选择服务项目',
        passportPic: '请上护照首页'
      },
      cateringNeeds: {
        label1: '素食',
        label2: '普通',
        label3: '清真餐食'
      },
      serviceProjects: {
        label1: '基础服务（后勤服务、报名服务、参与费）',
        label2: '附加服务（签证、EVUS更新）'
      }
    },
    btn: {
      save: '提 交',
      update: '重新提交',
      cancel: '取 消'
    },
    alert: {
      coachId: '数据错误，请重新登录后查看',
      success: '保存成功'
    }
  },
  team: {
    page: {
      title: '组队管理',
      tips: '请查看《组队说明》，并完成组队信息提交',
      details: '团队详情',
      filedes: '上传成绩证明文件*',
      schoolNum: '学校在读总人数*',
      explain: {
        line1: '请填写贵校的在读学生总人数，此数据将作为学校分组的依据，若有9年级学生参与，则需填写9-12年级的总人数。学校务必如实填写，如有不实，组委会将取消学校的参与资格。',
        line2: '* 如参与学生全部来自本部，则此处仅填写本部在读学生总人数。',
        line3: '* 如参与学生全部来自国际部，则此处对应仅填写国际部在读学生总人数。',
        line4: '* 如参与学生既有本部又有国际部，则填写本部与国际部在读学生人数的总和。',
        line5: '* 上述在读学生总人数应包含10至12年级总人数；如有9年级学生参与，则在读学生总人数为9至12年级总人数。'
      },
      usad: {
        teamdes1: '如有个人选手，添加方式同团队选手，但每位个人选手独立成队，请依次添加。提交信息后在',
        teamdes2: '',
        teamdes3: '',
        teamdes4: '日之前支持修改团队信息。',
        teamdes5: '* 团队信息：'
      },
      usap: {
        teamdes1: '如有个人选手，添加方式同团队选手，但每位个人选手独立成队，请依次添加。提交信息后在',
        teamdes2: '',
        teamdes3: '',
        teamdes4: '日之前支持修改团队信息。'
      },
      teamlable: '团队信息*'
    },
    placeholder: {
      schoolNum: '请输入学校在读总人数'
    },
    alert: {
      delfile: '请先删除文件后再上传',
      delfilecf: '确定移除',
      filesuccess: '上传成功',
      uploadfile: '请先上传成绩及分组证明文件',
      save: '请先提交或保存'
    },
    btn: {
      upload: '点击上传',
      download: '学生成绩及分组说明.xlsx',
      scoredown: '成绩及分组证明文件.xlsx',
      add: '添加队伍',
      agree: '确 认'
    }
  },
  teamdetail: {
    page: {
      groupName: '组别',
      enterName: '姓名',
      firstName: '拼音姓',
      lastName: '拼音名',
      gradeCode: '年级',
      gpaScore: 'GPA成绩',
      rateScore: '排名百分比（%）',
      totalScore: '总分',
      mathScore: '数学',
      englishScore: '英语语言',
      scienceScore: '科学',
      groupPersonNum: '学校分组测试参与总人数',
      leaderId: '队长',
      auditReason: '反馈原因',
      cancelTitle: '此操作将永久解散团队, 是否继续',
      cancelTip: '提 示',
      cancelConfirm: '确 定',
      cancelCancel: '取 消',
      unfold: '展开',
      fold: '收起',
      auditStatus: {
        label1: '审核中...',
        label2: '审核通过',
        label3: '审核不通过'
      },
      groupTypes: {
        label32: '荣誉组',
        label33: '学者组',
        label34: '队打组',
        label35: '荣誉组',
        label36: '学者组',
        label37: '队打组'
      }
    },
    placeholder: {
      enterName: '请选择队员'
    },
    alert: {
      timeLimit: '已过组队截止时间',
      gpaScore: '请填写学生gpa成绩',
      groupTestNum: '请先填写分组测试参与总人数',
      gpaScore0_5000: '荣誉组GPA成绩范围：0.000 ≤ X ≤ 4.000分',
      gpaScore0_3749: '学者组GPA成绩范围：0.000 ≤ X < 3.799分',
      gpaScore0_2999: '队打组GPA成绩范围：0.000 ≤ X <3.199分',
      rateScore: '请填写学生排名百分比',
      rateScore00_100: '荣誉组排名百分比范围：0.00% < X  ≤100.00%',
      rateScore20_100: '学者组排名百分比范围：20.00% < X  ≤100.00%',
      rateScore50_100: '队打组排名百分比范围：50.00% < X  ≤100.00%',
      users: '你还没有选择团队学生',
      userRange: '团队人数必须为1人或者 6 - 9 人',
      userLimit: '每个组别至少2-3人',
      userLimit2: '种子组别人数应该大于1人',
      leaderId: '请选择队长后再提交',
      recurrent: '用户已经在队伍中、请勿重复选择',
      cancelTeam: '团队还未组建成功不能解散',
      cancelSuc: ' 团队解散成功！',
      success0: '保存成功！',
      success1: '提交成功！',
      success2: '提交成功！'
    },
    btn: {
      gpa: 'GPA成绩',
      rate: '排名百分比',
      group: '分组测试',
      cancel: '解散团队',
      submit: '提 交',
      resubmit: '重新提交',
      save: '保 存'
    }
  },
  seed: {
    seed: '种子模式',
    classic: '全能模式',
    rules: '组队规则： 3-4人一队，不支持个人选手组队。'
  },
  user: {

  },
  restructure: {
    welcome: '欢迎来到教练端',
    switch: '切换活动',
    activity: '活动名称',
    select: '选择活动',
    selectPlaceholder: '请选择活动季',
    comingSoon: '该功能即将上线，敬请期待～',
    onlineTest: '线上考试',
    scoreReport: '学术报告',
    noData: '暂无数据',
    noData2: '请先选择作业',
    introduction: '课程简介：',
    to: '至',
    catalog: '目录',
    finished: '已完成',
    unfinished: '未完成',
    open: '展开',
    close: '收起',
    get: '获得',
    certification: '认证中心',
    download: '下载',
    share: '分享',
    remake: '重新制作',
    shareQr: '打开手机微信扫描二维码，分享证书到微信/朋友圈吧～',
    remakeCertificate: '重新制作证书',
    school: '学校',
    name: '姓名',
    cancel: '取消',
    confirm: '确认制作',
    tips: '每张证书仅可重新制作一次，请确认个人信息无误再重新生成',
    headPortrait: '头像',
    change: '换头像',
    tips2: '建议尺寸250*250，格式为JPG、PNG，图片小于3M',
    personalInformation: '个人信息',
    moreContacts: '更多联系人',
    accountSettings: '账号设置',
    account: '登录账号',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    changePassword: '更改密码',
    tips3: '其他需要接受活动公告的联系人和电子邮箱',
    previous: '上一题',
    next: '下一题',
    submit: '提交',
    answerSheet: '答题卡',
    answered: '已答',
    unanswered: '未答',
    single: '单选题',
    multiple: '多选题',
    completion: '填空题',
    score: '分数',
    numberOftopics: '题目数量',
    incorrectly: '答错',
    time: '用时',
    dao: '道',
    achievementReport: '学术报告',
    answerAnalysis: '答题分析',
    rightKey: '正确答案',
    yourAnswer: '你的答案',
    analysis: '解析',
    wrong: '答错',
    correct: '答对',
    whole: '全部试题',
    firstName: '拼音名',
    lastName: '拼音姓',
    title: {
      scoreQuery: '学术报告',
      registrationRecord: '报名记录',
      announcement: '活动公告',
      course: '教练课程',
      AdmissionTicket: '准考证',
      JobRecords: '作业记录'
    }
  },
  ...zhLocale
}
export default zh



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh.js